import { OccupancyValue, Room } from 'types/Search/form';

import { CustomState, OverviewState } from '../__reducer/types';

export function convertValueToOverviewData(
    value: OccupancyValue
): OverviewState {
    //aggregate adultCount and childAgeList over all rooms
    const overview: Room = value.reduce(
        (summary, room) => ({
            adultCount: summary.adultCount + room.adultCount,
            childAgeList: [...summary.childAgeList, ...room.childAgeList],
        }),
        {
            adultCount: 0,
            childAgeList: [],
        }
    );

    return {
        ...overview,
        roomCount: value.length,
    };
}

export function convertOverviewToValue(
    overview: OverviewState
): OccupancyValue {
    if (!isOverviewPossible(overview)) {
        throw new Error('overview not convertable to custom allocation');
    }

    return overview.roomCount === 1
        ? [
              {
                  adultCount: overview.adultCount,
                  childAgeList: overview.childAgeList,
              },
          ]
        : [...Array(overview.roomCount)].map(() => ({
              adultCount: 1,
              childAgeList: [],
          }));
}

const ADULT_REPRESENTATION = 'A';

export function buildUrlParamFromRoom(room: CustomState) {
    const adultValue = [...Array(room.adultCount)].map(
        () => ADULT_REPRESENTATION
    );

    return [...adultValue, ...room.childAgeList].join('-');
}

export const convertValueToUrlParam = (custom: CustomState[]) =>
    custom.map(buildUrlParamFromRoom).join(',');

function buildRoomFromUrlParam(param: string): Room {
    if (!param.length) {
        return {
            adultCount: 0,
            childAgeList: [],
        };
    }
    const occupants = param.split('-');
    const childAgeList = occupants
        .filter((occupant) => occupant !== ADULT_REPRESENTATION)
        .map(Number);

    return {
        adultCount: occupants.length - childAgeList.length,
        childAgeList,
    };
}

export const convertUrlParamToValue = (param: string): OccupancyValue =>
    param.split(',').map(buildRoomFromUrlParam);

export const isOverviewPossible = (overview: OverviewState) =>
    overview.roomCount === 1 ||
    (overview.roomCount === overview.adultCount &&
        overview.childAgeList.length === 0);
